import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-multiple-choice-multiple-response',
  templateUrl: './preview-multiple-choice-multiple-response.component.html',
  styleUrls: ['./preview-multiple-choice-multiple-response.component.scss']
})
export class PreviewMultipleChoiceMultipleResponseComponent {

  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  constructor(public sanitizer: DomSanitizer) { }
}
